import types from './advertisersTypes';

export const getAdvertisers=(value)=>({
  type:types.GET_ADVERTISER,
  payload:value,
})